module.exports = __webpack_public_path__ + "img/pause_e_retome_icon.1315b3f5.svg";